import { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import Button from "components/atoms/Button/Button";
import { ReactComponent as ExclamationIcon } from "assets/images/icons/Exclamation.svg";
import { IProviderProps } from "./quotes/QuotesType";

interface IRateCardProps {
  providers: IProviderProps[];
}

function RateCardErrors({ providers }: IRateCardProps) {
  const intl = useIntl();

  const rateCardErrors: any = [];

  const [errors, setErrors] = useState<string[]>([]);
  const [isExpanded, setIsExpanded] = useState(false);

  // Some error messages contain 2 errors in a single string, code below splits them up if this is the case.
  const formatErrorMessage = (errorMessage: string) => {
    if (!errorMessage) return;
    if (errorMessage.includes("\n")) {
      const messageParts = errorMessage.split("\n");
      rateCardErrors.push(messageParts[0]);
      rateCardErrors.push(messageParts[1]);
    } else rateCardErrors.push(errorMessage);
  };

  useEffect(() => {
    providers?.forEach(({ rate_card_error_message }) => {
      formatErrorMessage(rate_card_error_message);
    });
    setErrors([...rateCardErrors]);
  }, [providers]);

  useEffect(() => {
    if (errors?.length > 1) {
      const uniqueErrorRateCards = errors
        .map((item) => item.trim())
        .filter((value, index, self) => self.indexOf(value) === index);
      setErrors(uniqueErrorRateCards);
    }
  }, [errors?.length]);

  const onExpand = () => {
    setIsExpanded(!isExpanded);
  };

  if (errors && errors.length === 0) return null;

  return (
    <Row>
      <Col className="mb-xl" style={{ transform: "translateY(24px)" }}>
        {errors.length > 0 && (
          /* WEB-6959: In case warning needs to be shown again when rate card quotation is available, change bg color from bg-waring to bg-blue-50  */
          <div
            className="pb-4 pl-4 pr-3 pt-3 bg-warning"
            style={{ borderRadius: "16px 16px 0px 0px", paddingBottom: "10px" }}
          >
            {/* WEB-6959: In case warning needs to be shown again when rate card quotation is available, change text color from text-waring to text-blue-300  */}
            <div className="d-flex flex-column text-warning" style={{ verticalAlign: "text-top" }}>
              <div className="d-flex">
                <div>
                  <ExclamationIcon className="mr-3 custom-alert-warning-icon" style={{ minWidth: 16 }} />
                </div>

                <div>
                  {errors.slice(0, isExpanded ? errors.length : 2).map((error: string) => (
                    <div key={error}>{error}</div>
                  ))}
                  {errors.length > 2 && (
                    <div>
                      <Button variant="link" onClick={onExpand} className="font-weight-bold p-0 pt-2 pb-1 text-warning">
                        {isExpanded
                          ? intl.formatMessage({
                              id: "general.viewLess",
                              defaultMessage: "View less",
                            })
                          : intl.formatMessage({
                              id: "general.viewMore",
                              defaultMessage: "View more",
                            })}
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </Col>
    </Row>
  );
}

RateCardErrors.propTypes = {
  providers: PropTypes.arrayOf(PropTypes.shape({})),
};

RateCardErrors.defaultProps = {
  providers: null,
};

export default RateCardErrors;
